import React from "react";
import { Capacitor } from "@capacitor/core";
import useUpdateCheck from "../hooks/useUpdateCheck";
import useAccentColor from "../hooks/useAccentColor";
import styles from "../styles/UpdateBanner.module.css";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.onyxlife.app";
const APP_STORE_URL = "https://apps.apple.com/app/onyxlife/id0000000000"; // update when live

const UpdateBanner: React.FC = () => {
  const { available, latestVersion, isNative, dismiss } = useUpdateCheck();
  const { accent } = useAccentColor();

  if (!available) return null;

  const handleUpdate = () => {
    if (isNative) {
      const platform = Capacitor.getPlatform();
      const storeUrl = platform === "ios" ? APP_STORE_URL : PLAY_STORE_URL;
      window.open(storeUrl, "_system");
    } else {
      window.location.reload();
    }
  };

  return (
    <div
      className={styles.banner}
      style={{ backgroundColor: accent, color: "#fff" }}
    >
      <div className={styles.content}>
        <i className="fa-solid fa-arrow-up-from-bracket" style={{ marginRight: 8 }} />
        <span>
          {isNative
            ? `Update available (v${latestVersion})`
            : `A new version (v${latestVersion}) is available`}
        </span>
      </div>
      <div className={styles.actions}>
        <button
          className={styles.updateBtn}
          onClick={handleUpdate}
          style={{ color: accent }}
        >
          {isNative ? "Update" : "Refresh"}
        </button>
        <button
          className={styles.dismissBtn}
          onClick={dismiss}
          style={{ color: "#fff" }}
        >
          Later
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
